module.exports = __webpack_public_path__ + "static/media/freethrow-area.47ee8bfe.svg";